module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/.6.22.0@babel-runtime/core-js/array/from.js
 ** module id = 666
 ** module chunks = 0
 **/